<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/streams">Streams</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <div class="flex ml-8 mr-8 mt-8 mb-2 p-4 mb-4 text-sm text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800" role="alert">
        <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
        <span class="sr-only">Info</span>
        <div>
          <span class="font-medium">Important note!</span> Stream name must be same as the stream pushed to the media server.
        </div>
      </div>
      <stream-form
        :form="form"
        :projects="projects"
        :isTechnician="isTechnician"
        :canSelectProject="canSelectProject"
        :isAdmin="isAdmin"
        :isPartner="isPartner"
        submit-button-text="Update Stream"
        :submit="update"
      >
        <template #extra-actions>
          <button v-if="stream ?? stream.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete stream</button>
        </template>
      </stream-form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import StreamForm from '@/Pages/Streams/StreamForm.vue'

export default {
  components: {
    Head,
    Link,
    StreamForm,
  },
  layout: Layout,
  props: {
    stream: Object,
    projects: Array,
    loggedUser: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.stream.name,
        title: this.stream.title,
        color: this.stream.color,
        project_id: this.stream.project_id,
        orientation: this.stream.orientation,
      }),
    }
  },
  computed: {
    isAdmin() {
      return this.loggedUser.type === 'ADMIN'
    },
    isPartner() {
      return this.loggedUser.type === 'PARTNER'
    },
    isTechnician() {
      return this.loggedUser.type === 'TECHNICIAN'
    },
    canSelectProject() {
      return this.loggedUser.type === 'ADMIN' || this.loggedUser.type === 'PARTNER'
    },
  },
  mounted() {
    console.log(this.projects);
  },
  methods: {
    update() {
      this.form.put(`/streams/${this.stream.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this stream?')) {
        this.$inertia.delete(`/streams/${this.stream.id}`)
      }
    },
  },
}
</script>
